import { render, staticRenderFns } from "./MainHeaderVideoConfs.vue?vue&type=template&id=8dafcfd2&scoped=true&lang=pug&"
import script from "./MainHeaderVideoConfs.vue?vue&type=script&lang=js&"
export * from "./MainHeaderVideoConfs.vue?vue&type=script&lang=js&"
import style0 from "./MainHeaderVideoConfs.vue?vue&type=style&index=0&id=8dafcfd2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dafcfd2",
  null
  
)

export default component.exports